import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('ListItem', {
    staticClass: "custom-cascader",
    "class": _vm.clazz
  }, [_c('label', {
    "class": {
      'is-error': !_vm.isValidate
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v(_vm._s(_vm.title)), _vm.required ? _c('span', {
    staticClass: "list-required"
  }, [_vm._v("*")]) : _vm._e()]), _c('div', {
    staticClass: "list-item-content",
    "class": [_vm.name.length === 0 ? 'placeholder' : '', _vm.textAlign],
    attrs: {
      "slot": "content"
    },
    on: {
      "click": _vm.onClickPlaceholder
    },
    slot: "content"
  }, [_vm._v(" " + _vm._s(_vm.name || _vm.placeholder) + " ")]), _vm.rightArrow ? _c('div', {
    staticClass: "custom-cascader__arrows",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#iconxiangyou"
    }
  })])]) : _vm._e(), _c('van-popup', {
    attrs: {
      "slot": "extra",
      "close-on-click-overlay": !_vm.moreColumnVisible,
      "position": "bottom"
    },
    slot: "extra",
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('Cascader', {
    attrs: {
      "fetchList": _vm.fetchList
    },
    on: {
      "itemMap": _vm.onItemMapUpate,
      "listMap": _vm.onListMapUpate,
      "finish": _vm.onFinish
    },
    model: {
      value: _vm.ids,
      callback: function callback($$v) {
        _vm.ids = $$v;
      },
      expression: "ids"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };